import { StylesConfig } from 'react-select';
import { CSSObjectWithLabel } from 'react-select/dist/declarations/src/types';

// export const StyledSelectFormCell = styled(FormCell)`
// .select {
//   ${(props) => props.theme.fonts.mixins.body};
//   .select__control {
//     ${InputCss};
//     ${(props) => props.theme.fonts.mixins.body};
//     padding: ${(props) => `${props.theme.spacing.baseValue / 4}${props.theme.spacing.baseUnit}`};
//     box-sizing: border-box;
//     box-shadow: 0px 1px 2px ${(props) => props.theme.colors.focusHoverShadow};
//
//     .select__multi-value__remove {
//       color: ${(props) => props.theme.colors.gray600};
//     }
//
//     .select__multi-value__label {
//       color: ${(props) => props.theme.colors.defaultContentText};
//       line-height: 14.5px;
//     }
//
//     .select__single-value {
//       grid-area: 1/1/2/3;
//       margin: 0;
//       max-width: 100%;
//       overflow: hidden;
//       text-overflow: ellipsis;
//       white-space: nowrap;
//     }
//
//     &.select__control--is-disabled {
//       ${inputReadOnlyMixin}
//     }
//
//     &:hover {
//       ${hoverInputStyle};
//     }
//   }
//
//   .select__control--is-focused {
//     border: 1px solid
//       ${(props) => (props.showErrorHighlight ? props.theme.colors.errorBorder : props.theme.colors.primary)};
//     box-shadow:
//       0px 1px 2px ${(props) => props.theme.colors.focusHoverShadow},
//       0px 0px 0px 1px ${(props) => props.theme.colors.primary};
//   }
//
//   .select__value-container {
//     padding: 2px 8px;
//     position: relative;
//     display: flex;
//     flex-wrap: wrap;
//     align-items: center;
//   }
//
//   .select__placeholder {
//     // color: ${(props) => props.theme.colors.contentPlaceholder};
//
//     position: absolute;
//     color: ${(props) => props.theme.colors.gray500};
//
//     // Ensure it doesn't block the input cursor
//     pointer-events: none;
//
//     // Proper alignment
//     transform: translateY(0);
//     margin: 0;
//   }
//
//   // 3. Style the input container for proper cursor positioning
//   .select__input-container {
//     margin: 0;
//     padding: 0;
//
//     // Ensure it takes precedence over the placeholder
//     position: relative;
//
//     // Allow it to expand to fill available space
//     flex: 1 1 auto;
//
//     // Ensure text aligns with placeholder
//     display: inline-grid;
//     grid-area: 1/1/2/3;
//
//     // Remove any margins that might affect cursor position
//     input {
//       margin: 0;
//       min-width: 2px;
//       grid-area: 1/1/2/3;
//     }
//   }
//
//   .select__indicators {
//     align-items: center;
//     align-self: stretch;
//     box-sizing: border-box;
//     flex-shrink: 0;
//     display: flex;
//   }
//
//   .select__indicator {
//     padding: 0 ${(props) => props.theme.spacing.spacing4} ${(props) => props.theme.spacing.spacing2} 0;
//     cursor: pointer;
//   }
//
//   .select__dropdown-indicator {
//     transform: rotate(180deg);
//     padding: ${(props) => props.theme.spacing.spacing2} ${(props) => props.theme.spacing.spacing3}
//       ${(props) => props.theme.spacing.spacing2} ${(props) => props.theme.spacing.spacing3};
//   }
//
//   .select__menu {
//     border: 1px solid ${(props) => props.theme.colors.defaultContentBorder};
//     position: absolute;
//     background-color: ${(props) => props.theme.colors.defaultContentBackground};
//     white-space: normal;
//     width: 100%;
//     z-index: 1;
//     line-height: 20px;
//
//     &-list {
//       max-height: 200px;
//       box-sizing: border-box;
//       overflow-y: auto;
//       position: relative;
//     }
//   }
//
//   .select__group-heading {
//     color: ${(props) => props.theme.colors.gray500};
//     background: ${(props) => props.theme.colors.gray100};
//     font-family: 'Open Sans', sans-serif;
//     ${(props) => props.theme.fonts.tinySize};
//     ${(props) => props.theme.fonts.mixins.boldBody};
//     text-transform: uppercase;
//     padding: ${(props) => props.theme.spacing.spacing4};
//   }
//
//   .select__option {
//     padding: ${(props) => props.theme.spacing.spacing4};
//     line-height: 1.3;
//
//     &.select__option--is-focused {
//       background-color: ${(props) => props.theme.colors.gray50};
//       color: ${(props) => props.theme.colors.defaultContentText};
//     }
//   }
//
//   .select__option--is-selected {
//     background-color: ${(props) => props.theme.colors.gray200};
//     color: ${(props) => props.theme.colors.defaultContentText};
//   }
//
//   .input-read-only {
//     ${inputReadOnlyMixin};
//     .select__single-value--is-disabled {
//       ${disabledInputStyle};
//     }
//   }
//
//   .select__option--is-disabled {
//     ${disabledInputStyle};
//   }
// }
// `;

const fontStyles: CSSObjectWithLabel = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 'normal',
};

// If we need to adjust styles, we can do so here. I have commented the old styles as a reference.
export const defaultSelectStyles: StylesConfig = {
  option: (base) => ({ ...base, ...fontStyles, textWrap: 'wrap' }),
  placeholder: (base) => ({ ...base, ...fontStyles }),
  control: (base) => ({ ...base, ...fontStyles }),
  singleValue: (base) => ({ ...base, ...fontStyles }),
};
